module.exports = __webpack_public_path__ + "img/22.1ed4639c.jpg";